module.exports = __webpack_public_path__ + "12279ffbcfd135cceebdf911b61aa259.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/cube_yellow.png
 ** module id = 1052
 ** module chunks = 0
 **/